import { type FC, type ReactNode } from 'react'
import { Button, SpinnerLoader, Typography } from 'shared/ui'
import styles from './styles.module.scss'

type ISectionProps = {
  title: string
  linkTitle?: string
  onClickLinkTitle?: () => void
  loading: boolean
  notResult: boolean
  notResultTitle: string
  children: ReactNode
}

export const SectionBase: FC<ISectionProps> = ({
  title,
  linkTitle,
  onClickLinkTitle,
  children,
  loading,
  notResult,
  notResultTitle,
}) => {
  const renderContent = () => {
    if (loading) {
      return (
        <div className={styles.content}>
          <SpinnerLoader ariaLabel={'SectionContacts'} size={20} />
        </div>
      )
    }

    if (notResult) {
      return (
        <div className={styles.content}>
          <Typography
            tag={'div'}
            className={styles.notResult}
            variant={'body-sm-regular'}
            ariaLabel={'SectionContacts_notResult'}
          >
            {notResultTitle}
          </Typography>
        </div>
      )
    }

    return (
      <>
        <div className={styles.content}>{children}</div>
        <div className={styles.linkWrap}>
          <Button
            text={linkTitle}
            size={'medium'}
            typeBtn={'informative'}
            onClick={() => {
              onClickLinkTitle?.()
            }}
          />
        </div>
      </>
    )
  }

  return (
    <div className={styles.wrap}>
      <Typography
        className={styles.title}
        tag={'div'}
        variant={'body-md-medium'}
        ariaLabel={'section_title'}
      >
        {title}
      </Typography>

      {renderContent()}
    </div>
  )
}
